export const TYPE_REPORTS = {
  ALL_REPORTS: 'ALL_REPORTS',
  BUSINESS: 'BUSINESS',
  MARKET: 'MARKET',
  FIIN_RATING: 'FIIN_RATING',
}

export const TYPE_REPORTS_SELECT = {
  [TYPE_REPORTS.ALL_REPORTS]: {
    label: 'dashboard.latestReport.allReports',
    value: undefined,
    isI18n: true,
    id: 0,
  },
  [TYPE_REPORTS.BUSINESS]: {
    label: 'Business Credit Reports',
    value: 'BusinessCredit',
    id: 1,
  },
  [TYPE_REPORTS.MARKET]: {
    label: 'Market Reseach Reports',
    value: 'MarketResearch',
    id: 2,
  },
  [TYPE_REPORTS.FIIN_RATING]: {
    label: 'FiinRatings Reports ',
    value: 'FiinRatings',
    id: 3,
  },
}

export const VALUE_TABLE_LATEST_REPORTS = [
  {
    key: 'title',
    value: 'dashboard.latestReport.reportName',
  },
  {
    key: 'reportTypeName',
    value: 'dashboard.latestReport.category',
  },
  {
    key: 'publicDateId',
    value: 'dashboard.latestReport.publicDate',
  },
]
